import React, { FunctionComponent, memo, ReactElement } from 'react'
import Grid from '@sport1/react-elements/Grid'
import { BackgroundColorTypes } from '../../Theme/Fonts/FontTypes'
import { TestID } from '../../utils/PropTypesDefinitions'
import NavigationTitle from '../../Theme/Fonts/NavigationTitle'
import NavigationBarButton from '../../BaseComponents/Button/NavigationBar'
import { NavigationBarIconProps } from '../NavigationIconRow'

export type NavigationBarProps = {
    /**
     * will be displayed with align left between the left- and right-component
     */
    mainComponent?: ReactElement | string
    /**
     * icon on the left side
     */
    leftIcon?: NavigationBarIconProps
    /**
     * component displayed on the right side (e.g. <NavigationIconRow />)
     */
    rightComponent?: ReactElement
    /**
     * backgroundColor of the component
     */
    backgroundColor?: BackgroundColorTypes
} & TestID

const NavigationBar: FunctionComponent<NavigationBarProps> = ({
    mainComponent,
    leftIcon,
    rightComponent,
    backgroundColor = 'BLACK',
    testID,
}): ReactElement => {
    return (
        <Grid
            noExpand
            horizontal
            centerVertical
            backgroundColor={backgroundColor}
            testID={testID}
            minHeight={44}
        >
            {leftIcon ? (
                <NavigationBarButton
                    name={leftIcon.name}
                    color={leftIcon.color}
                    onPress={leftIcon.onPress}
                    size={leftIcon.size}
                    testID={leftIcon.testID}
                />
            ) : null}
            {mainComponent ? (
                <Grid
                    pointerEvents="box-none"
                    zIndex={10}
                    minWidth={0}
                    marginLeft={!leftIcon ? 5 : null}
                >
                    {typeof mainComponent === 'string' ? (
                        <NavigationTitle numberOfLines={1} fontSize="FS18">
                            {mainComponent}
                        </NavigationTitle>
                    ) : (
                        mainComponent
                    )}
                </Grid>
            ) : (
                <Grid />
            )}
            {rightComponent}
        </Grid>
    )
}

export default memo(NavigationBar)
